import { Route } from 'react-router-dom-v5-compat';

import ReportDetails from 'dashboard/components/ReportDetails';
import { SentryRoutes } from 'dashboard/components/SentryRoute/SentryRoute';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Report } from 'dashboard/models/report';
import ReportsTable, {
  ReportsTableColumns,
} from 'dashboard/views/DashboardReportsView/ReportsTable';
import Card from 'design-system/components/Card';

interface InquiryReportsProps {
  isLoading: boolean;
  reports: Report[];
}

const InquiryReports = ({ reports, isLoading }: InquiryReportsProps) => {
  return (
    <SentryRoutes>
      <Route
        index
        element={
          <Card>
            <Card.Body>
              <ReportsTable
                reports={reports}
                /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
                sortParams={{ sort: null, shouldSortDescending: true } as SortParams}
                isLoading={isLoading}
                hasUsedFilters={true}
                visibleColumns={[
                  ReportsTableColumns.PrimaryInput,
                  ReportsTableColumns.Status,
                  ReportsTableColumns.ReportId,
                  ReportsTableColumns.LastUpdatedAt,
                ]}
                handleSortUpdate={() => null}
              />
            </Card.Body>
          </Card>
        }
      />
      {reports.map((report) => (
        <Route
          key={`report-show-route-${report.id}`}
          path={report.id + '/*'}
          element={<ReportDetails report={report} />}
        />
      ))}
    </SentryRoutes>
  );
};

export default InquiryReports;
